export default "__VITE_ASSET__CrBxokh0__";